import { SalesCreditRoleAdmin } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

export interface SalesCreditRolesState {
    salesCreditRoles: SalesCreditRoleAdmin[] | undefined;
    loaded: boolean;
    loading: boolean;
    error: AppError | null;
}

export const initialSalesCreditRolesState: SalesCreditRolesState = {
    salesCreditRoles: undefined,
    loaded: false,
    loading: false,
    error: null,
};
